import React, { useContext, useState } from 'react';
import { BdsButton, BdsAlert, BdsAlertHeader, BdsAlertBody, BdsAlertActions } from 'blip-ds/dist/blip-ds-react';
import '../../styles.scss';
import { useContentLocalizer } from '../../../../hooks/useContentLocalizer';
import { localization } from './localization';
import MtlsContext from '../../../../contexts/MtlsContext';
import { showToast } from '../../../../api/CommonApi';

const RemoveHost: React.FC = () => {
  const {
    removeHostAlert,
    closeRemoveHostAlert,
    toggleHostsModal,
    mtlsCertificateApi,
    tenantId,
    setMtlsCertificate,
    mtlsCertificate,
    setCertificateUpdatedProps,
    certificateUpdatedProps,
  } = useContext(MtlsContext);
  const content = useContentLocalizer(localization);
  const [isLoading, setIsLoading] = useState(false);

  const certificateAlert = document.getElementById('remove-host-alert');
  const shadowRoot = certificateAlert?.shadowRoot?.querySelector('.alert__dialog .alert');
  shadowRoot?.setAttribute('style', 'position:relative;margin:auto;top: 40%;');

  const handleDeleteHost = async () => {
    try {
      setIsLoading(true);
      await mtlsCertificateApi.deleteHost(tenantId, certificateUpdatedProps.hostId);
      const responseStatus = mtlsCertificateApi.getStatus();
      if (responseStatus == 'success') {
        const updatedCertificate = mtlsCertificate?.map((item) => {
          if (item.certificate_id === certificateUpdatedProps.certificateId) {
            return {
              ...item,
              hosts: item.hosts.filter((host) => host.host_id !== certificateUpdatedProps.hostId),
            };
          }
          return item;
        });
        setMtlsCertificate(updatedCertificate);
        setCertificateUpdatedProps({ ...certificateUpdatedProps, hostUpdated: !certificateUpdatedProps.hostUpdated });

        const currentCertificate = updatedCertificate?.filter((item) => {
          return item.certificate_id == certificateUpdatedProps.certificateId;
        });

        closeRemoveHostAlert();

        if (currentCertificate[0].hosts.length == 0) {
          toggleHostsModal();
          setTimeout(() => {
            setCertificateUpdatedProps({
              ...certificateUpdatedProps,
              certificateUpdated: !certificateUpdatedProps.certificateUpdated,
            });
          }, 1000);
        }
        showToast({
          type: 'success',
          message: content.successRemovedHost,
        });
      } else {
        showToast({
          type: 'danger',
          message: content.failRemovedHost,
        });
      }
    } catch (error) {
      showToast({
        type: 'danger',
        message: content.failRemovedHost,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseHostAlert = () => {
    if (isLoading) return;
    closeRemoveHostAlert();
  };

  return (
    <BdsAlert id="remove-host-alert" open={removeHostAlert}>
      <BdsAlertHeader variant="warning" icon="warning">
        {content.caution}
      </BdsAlertHeader>
      <BdsAlertBody>{content.confirmMessage}</BdsAlertBody>
      <BdsAlertActions>
        <BdsButton disabled={isLoading} variant="secondary" onClick={handleCloseHostAlert}>
          {content.cancel}
        </BdsButton>
        <BdsButton bdsLoading={isLoading} variant="secondary" onClick={handleDeleteHost}>
          {content.disable}
        </BdsButton>
      </BdsAlertActions>
    </BdsAlert>
  );
};

export default RemoveHost;
